import { paletteVar } from "@platform/design-system";

import { financialsRowKinds } from "./types";

import type { FinancialsRow } from "./types";
import type { RowStyle } from "ag-grid-community";

// Scheme-aware so the header rows follow dark mode; the original literals stay as
// fallbacks, so a theme without CSS vars renders them unchanged.
const TOTALS_BACKGROUND = paletteVar("action-selected", "#e3f2fd");
const COVERAGE_HEADER_BACKGROUND = paletteVar("surfaces-neutral", "#f5f5f5");

/**
 * Row styling callback. Coverage headers and totals headers get
 * distinct backgrounds; all other rows use the default.
 */
export const getFinancialsRowStyle = (params: {
  data?: FinancialsRow;
}): RowStyle | undefined => {
  if (!params.data) return undefined;

  if (params.data.kind === financialsRowKinds.TOTALS_HEADER) {
    return { background: TOTALS_BACKGROUND };
  }

  if (params.data.kind === financialsRowKinds.COVERAGE_HEADER) {
    return { background: COVERAGE_HEADER_BACKGROUND };
  }

  return undefined;
};
